/**
 * @fileoverview Standalone Angular 21 Component for Chat V2 Container.
 * Provides a responsive container query wrapper and layout boundary for Chat V2 messages.
 */

import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @class ChatV2ContainerComponent
 * @description Serves as the outer scrolling and container-query host for Chat V2 views.
 */
@Component({
  selector: 'rapider-chat-v2-container',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      [class]="
        'chat-v2-container flex-1 overflow-y-auto custom-scrollbar p-2 lg:p-2 flex flex-col min-h-0 relative ' +
        (customClass || '')
      "
    >
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./chat-v2-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatV2ContainerComponent {
  private readonly cdr = inject(ChangeDetectorRef);
  private _customClass = '';

  /**
   * Optional additional CSS classes to append to the container element.
   */
  @Input()
  public set customClass(val: string) {
    this._customClass = val;
    this.cdr.markForCheck();
  }

  public get customClass(): string {
    return this._customClass;
  }
}
